<template>
  <div>
    <Nav />
    <div>
      <div
        class="modal size-guide-popup-container"
        v-bind:class="{ active: this.$root.login_popup === true }"
        id="coupon-modal"
      >
        <div class="modal-dialog" style="max-width: 530px">
          <div class="modal-content">
            <div class="modal-body">
              <!-- class="close" -->
              <button
                type="button"
                class="close popupClose"
                @click="close_login_popup()"
              >
                x
              </button>
              <Login />
            </div>
          </div>
        </div>
      </div>
      <Modal />
    </div>

    <div class="locationDesktop" v-if="isActive">
      <div class="locationPicker">
        <div class="close">X</div>
        <p class="text">Search Location.</p>
        <input class="location" placeholder="Enter Your Location" type="text" />
        <div class="location picker">Get Current Location</div>
      </div>
      <div class="overlay"></div>
    </div>
  </div>

  <!-- <div class="container-fluid">
    <Logo />
    <Menu />
    <Account_dashboard />
  </div> -->
</template>
<style scoped>
.overlay {
  z-index: 999999999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--font-dark-blue);
  opacity: 0.7;
  overflow: hidden;
}
.locationPicker {
  z-index: 999999999990;
  position: fixed;
  top: 0;
  left: 0;
  width: 30%;
  height: 100vh;
  background: #ffffff;
  opacity: 1;
  padding-left: 120px;
  padding-right: 40px;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}
.text {
  display: none;
}
.close {
  position: absolute;
  top: 60px;
  /* left: 100px; */
  color: black;
  z-index: 999999999999;
}
.location {
  background-color: transparent;
  line-height: normal;
  border: none;
  outline: none;
  height: 70px;
  width: 100%;
  font-size: 17px;
  margin: 0;
  padding: 0 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
  border-radius: 0;

  font-weight: 500;
  border: 1px solid #d4d5d9;
}
.location.picker {
  display: flex;
  /* justify-content: center; */
  align-items: center;
}
.location.picker::before {
  content: "\003A6";
  margin-right: 20px;
}
.location.picker:hover {
  color: red;
}
/* Responsive  */
@media screen and (max-width: 767px) {
  .text {
    display: block;
    font-weight: bold;
    font-family: lhmSemiBold;
  }
  .locationPicker {
    z-index: 999999999990;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    top: 30%;
    /* height: 80vh; */
    background: #ffffff;
    opacity: 1;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: flex-start;
  }
  .close {
    position: absolute;
    top: -40px;
    /* left: 80%; */
    color: black;
    z-index: 999999999999;
  }

  .location {
    background-color: transparent;
    line-height: normal;
    border: none;
    outline: none;
    height: 40px;
    width: 90%;
    font-size: 17px;
    margin: 0;
    padding: 0 10px;
    margin-bottom: 20px;
    box-sizing: border-box;
    border-radius: 5px;
    display: block;
    font-weight: 500;
    border: 1px solid #d4d5d9;
  }
  .location.picker {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    border: 1px solid #ffffff !important;
    color: red;
  }
}
</style>
<script>
import Nav from "./Nav.vue";
import Login from "./Login";
import Modal from "../Home/Modal";

export default {
  name: "Header",
  components: {
    Nav,
    Login,
    Modal,
  },

  data() {
    return {
      isActive: false,
      search: "",
    };
  },
  methods: {
    login_popup_show(e) {
      e.preventDefault();
      this.$root.login_popup = true;
    },
    close_login_popup() {
      this.$root.login_popup = false;
    },
    checkout_gtm: function () {
      this.$gtm.trackEvent({
        event: "checkout",
        category: "Ecommerce",
        action: "Checkout",
        label: "1",
        ecommerce: {
          checkout: {
            actionField: { step: 1, option: this.$root.login_status },
            product: this.$root.gtm_product,
          },
        },
      });
    },
    menu_toggle: function (event) {
      if (this.$root.menuActive) {
        this.$root.menuActive = false;
      } else {
        this.$root.menuActive = true;
      }
    },
    minicart_show_hide: function (event) {
      if (this.$root.minicart) {
        this.$root.minicart = false;
      } else {
        this.$root.minicart = true;
      }
    },
    log_out: function () {
      $cookies.set(
        window.location.hostname.substring(10, 4) + "_customer",
        "1y"
      );
      $cookies.set(window.location.hostname.substring(10, 4) + "_cs", "", "1y");
      this.$root.customer_id = "";
      this.$root.customer_session = "";
      this.$root.cart_session = "";
      this.$root.cart_product = [];
      $cookies.set(
        window.location.hostname.substring(10, 4) + "_cart",
        "",
        "1y"
      );
      $cookies.set(
        window.location.hostname.substring(10, 4) + "_carts",
        "",
        "1y"
      );
      this.$root.cart_id = "";
      this.$toast.success("You have been successfully logout", {
        position: "top-right",
        duration: 4000,
      });
      // this.$root.success_message = "You have been successfully logout";
      location.reload(true);
    },
    deleteEvent: function (index) {
      this.$gtm.trackEvent({
        event: "removeFromCart",
        category: "cart",
        action: "Remove From Cart",
        label: name,
        cart: {
          remove: {
            product: [
              {
                name: this.$root.cart_product[index].name,
                id: this.$root.cart_product[index].master_sku,
                price: this.$root.cart_product[index].selling_price,
                category: "",
                variant: this.$root.cart_product[index].size,
                quantity: this.$root.cart_product[index].qty,
              },
            ],
          },
        },
      });
      this.$root.success_message = "";
      this.$root.error_message = "";
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("cart_id", this.$root.cart_id);
      form.append("cart_session", this.$root.cart_session);
      form.append("product_id", this.$root.cart_product[index].variant_id);
      axios
        .post(this.$root.cart_api + "/product/remove-product", form)
        .then((response) => {
          if (response.data.success === true) {
            this.$root.page_loader = false;
            this.$root.success_message = response.data.message;
            this.$root.error_message = "";
            this.$root.cart_product = response.data.data.products;
            this.$root.discount_code = response.data.data.discount_code;
            this.$root.discount_amount = response.data.data.discount_amount;
          } else {
            this.$root.page_loader = false;
            this.$root.success_message = "";
            this.$root.error_message = response.data.message;
            if (response.data.cart_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_carts",
                "",
                "1y"
              );
              this.$root.cart_id = "";
              this.$root.cart_session = "";
              this.$root.cart_product = [];
            }
          }
        })
        .catch((error) => {
          this.$root.page_loader = false;
          this.$root.error_message = error.message;
          window.scrollTo(0, 0);
        });
    },
  },
};
</script>